var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#34AADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01601 11.1911C5.01601 11.1911 11.5529 8.43783 13.82 7.46835C14.6891 7.08059 17.6363 5.83966 17.6363 5.83966C17.6363 5.83966 18.9966 5.29679 18.8832 6.61523C18.8454 7.15814 18.5432 9.05824 18.2409 11.1135C17.7874 14.0219 17.2962 17.2017 17.2962 17.2017C17.2962 17.2017 17.2207 18.0936 16.5783 18.2487C15.936 18.4038 14.878 17.7058 14.6891 17.5507C14.5379 17.4344 11.8552 15.6893 10.8727 14.8362C10.6082 14.6035 10.306 14.1382 10.9105 13.5953C12.2708 12.3156 13.8955 10.7257 14.878 9.71751C15.3314 9.25215 15.7848 8.16637 13.8955 9.4848C11.2128 11.385 8.56783 13.1688 8.56783 13.1688C8.56783 13.1688 7.96325 13.5565 6.8297 13.2075C5.6961 12.8585 4.37361 12.3932 4.37361 12.3932C4.37361 12.3932 3.46682 11.8115 5.01601 11.1911Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.1aa85c394ac2dffb721dd2863fd3b84f.svg";
export { ForwardRef as ReactComponent };